export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAIAAADZSiLoAAAAF0lEQVR4nGNgYGBgYGD4z8DAxAADCBYAF0MBBEt8FGsAAAAASUVORK5CYII="